<template>
  <Modal v-if="message !== null"
         ref="partnerInformationModal"
         :title="message.title"
         :visible="true"
         :no-enforce-focus="true"
         class="partnerInformationModal"
         :size="message.isSurvey ? BootstrapVariant.LARGE : BootstrapVariant.XLARGE"
         :static="true"
         @close="hide"
         @hide="onHide">
    <div id="message-body">
      <div v-if="message.isSurvey"
           v-html="message.text"></div>
      <p v-else>{{ message.text }}</p>
    </div>
    <template #modal-footer>
      <div class="w-100">
        <div v-if="message.isSurvey"
             class="float-right">
          <div class="text-right">
            <ButtonElement class="mr-2"
                           :text="tr('javascript.TX_SURVEY_NO')"
                           icon-name="cross"
                           :variant="BootstrapVariant.SECONDARY"
                           @click="updateMessage">
            </ButtonElement>
            <ButtonElement :text="tr('javascript.TX_SURVEY_LATER')"
                           icon-name="clock"
                           :variant="BootstrapVariant.SECONDARY"
                           @click="showNextMessage">
            </ButtonElement>
          </div>
        </div>
        <div v-else
             class="w-100 d-flex justify-content-between align-items-center">
          <span>
            {{ tr('javascript.LBL_MESSAGES') }} ( {{ messageNumber }} / {{ messages.length }} )
          </span>
          <div>
            <ButtonElement v-if="message.isEvent"
                           class="mr-2"
                           :text="tr('javascript.TX_CALENDAR_DOWNLOAD')"
                           icon-name="calendar"
                           :variant="BootstrapVariant.SECONDARY"
                           @click="downloadICal">
            </ButtonElement>
            <ButtonElement class="mr-2"
                           :text="tr('javascript.TX_LATER')"
                           icon-name="clock"
                           :variant="BootstrapVariant.SECONDARY"
                           @click="showNextMessage">
            </ButtonElement>
            <ButtonElement class="mr-2"
                           :text="tr('javascript.TX_READ')"
                           icon-name="checkmark"
                           :variant="BootstrapVariant.PRIMARY"
                           @click="updateMessage">
            </ButtonElement>
          </div>
        </div>
      </div>
    </template>
  </Modal>
</template>

<script>
  import Modal from '@common/layout/Modal.vue';
  import ButtonElement from '@common/layout/ButtonElement.vue';
  import { translator } from '~/zf/frontend/common/mixins';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  export default {
    name: 'PartnerInformationModal',
    compatConfig: {
      MODE: 3,
    },
    components: {
      Modal,
      ButtonElement,
    },
    mixins: [translator],
    props: {
      messages: Array,
    },
    emits: ['remove-modal-from-dom', 'update-message'],
    data() {
      return {
        BootstrapVariant,
        index: null,
        message: null,
        messageNumber: null,
      };
    },
    mounted() {
      if (this.messages !== null) {
        [this.message] = this.messages;
        this.messageNumber = 1;
      }
    },
    methods: {
      hide() {
        this.$refs.partnerInformationModal.hide();
      },
      onHide() {
        this.$emit('remove-modal-from-dom');
      },
      updateMessage() {
        this.$emit('update-message', this.message.messageId);
        this.showNextMessage();
      },
      showNextMessage() {
        this.index += 1;
        this.messageNumber += 1;
        const noMoreMessages = this.messages.length === this.index;
        if (noMoreMessages === true) {
          this.hide();
          this.message = null;
        } else {
          this.message = this.messages[this.index];
        }
      },
      downloadICal() {
        const leadingZero = '0';
        const eventStartDate = new Date(this.message.eventStart);
        const formattedStartDate = `${eventStartDate.getUTCFullYear()}\
${leadingZero.concat((eventStartDate.getUTCMonth() + 1).toString()).slice(-2)}\
${leadingZero.concat(eventStartDate.getUTCDate().toString()).slice(-2)}T\
${leadingZero.concat(eventStartDate.getUTCHours().toString()).slice(-2)}\
${leadingZero.concat(eventStartDate.getUTCMinutes().toString()).slice(-2)}\
${leadingZero.concat(eventStartDate.getUTCSeconds().toString()).slice(-2)}Z`;
        const eventEndDate = new Date(this.message.eventEnd);
        const formattedEndDate = `${eventEndDate.getUTCFullYear()}\
${leadingZero.concat((eventEndDate.getUTCMonth() + 1).toString()).slice(-2)}\
${leadingZero.concat(eventEndDate.getUTCDate().toString()).slice(-2)}T\
${leadingZero.concat(eventEndDate.getUTCHours().toString()).slice(-2)}\
${leadingZero.concat(eventEndDate.getUTCMinutes().toString()).slice(-2)}\
${leadingZero.concat(eventEndDate.getUTCSeconds().toString()).slice(-2)}Z`;
        const creationDate = new Date();
        const formattedCreationDate = `${creationDate.getFullYear()}\
${leadingZero.concat((creationDate.getMonth() + 1).toString()).slice(-2)}\
${leadingZero.concat(creationDate.getDate().toString()).slice(-2)}T\
${leadingZero.concat(creationDate.getHours().toString()).slice(-2)}\
${leadingZero.concat(creationDate.getMinutes().toString()).slice(-2)}\
${leadingZero.concat(creationDate.getSeconds().toString()).slice(-2)}Z`;
        const iCalContent = `\
BEGIN:VCALENDAR
VERSION:2.0
PRODID:https://www.meteocontrol.de
METHOD:PUBLISH
BEGIN:VEVENT
UID:${Date.now()}@meteocontrol.de
SUMMARY:${this.message.title}
DESCRIPTION:${(this.message.text).replace(/(?:\r\n|\r|\n)/g, '\\n')}
CLASS:PUBLIC
DTSTART:${formattedStartDate}
DTEND:${formattedEndDate}
DTSTAMP:${formattedCreationDate}
END:VEVENT
END:VCALENDAR\
`;
        const pseudoLinkElement = document.createElement('a');
        pseudoLinkElement.setAttribute('href', `data:text/calendar;charste=utf-8,${encodeURIComponent(iCalContent)}`);
        pseudoLinkElement.setAttribute('download', `${this.message.title}.ics`);
        pseudoLinkElement.style.display = 'none';
        document.body.appendChild(pseudoLinkElement);
        pseudoLinkElement.click();
        document.body.removeChild(pseudoLinkElement);
      },
    },
  };
</script>

<style scoped>
    .partnerInformationModal :deep(.modal-body) {
      max-height: 80vh;
      min-height: 10vh;
      overflow-y: auto;
    }

    #message-body {
      white-space: pre-wrap;
    }

    :deep(.modal-footer > div) {
      width: 100%;
    }
</style>
